// This file was automatically generated from enterName.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.enterName');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.multiuser_access.signup');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.enterName.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><form id="main-form"><h3 class="el8BrandColor el8LightWeight el8AlignCenter">View charts sent to your practice via Elation</h3><div class="el8MdSpacer"></div><div class="el8FormHorizontal el8FaxSignupForm"><h5 class="el8AlignCenter">Per HIPAA requirements, we need a little information about you.</h5><div class="el8Row el8FormGroup"><label class="el8StandardInputLabel el8Col5">My role in the practice is</label><div class="el8Col6"><label class="el8RadioInline"><input name="role" type="radio" value="clinician"></input>Provider</label><label class="el8RadioInline"><input name="role" type="radio" value="staff"></input>Office Staff</label></div></div><div class="detail-container">');
  el8.template.multiuser_access.signup.physicianNamesChooser(opt_data, output);
  el8.template.multiuser_access.signup.signupName(opt_data, output);
  el8.template.multiuser_access.signup.designation(opt_data, output);
  output.append('<div class="el8SmSpacer"></div></div></div><!-- el8FormHorizontal --><div class="el8MdSpacer"></div><div class="el8AlignCenter detail-container"><p>By clicking below, I agree to the <a class="eula-link" href="">Elation Terms and Conditions</a></p><button id="go-to-chart" class="el8Btn el8BtnPrimary">View Patient Information</button></div></form></div>');
  if (!opt_sb) return output.toString();
};
